import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import Config from '../../utils/config.service';
import ConciergeService from '../../services/concierge.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import RoutingService from '../../services/routing.service';

@Component({
	standalone: true,
	selector: 'concierge-service',
	templateUrl: './concierge-service.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export default class ConciergeServiceView implements OnInit, OnDestroy {
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private conciergeService: ConciergeService = inject(ConciergeService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	watcher: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('booking').then(() => {
			this.onResolve();
		});
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	onResolve() {
		this.vm.serviceId = this.angularRoutingHelperService.getRouteParam('serviceId');
		this.vm.bookingPreliminaryCheck = {};
		this.vm.isClosed = true;
		this.vm.startTimeInHours = 9;
		this.vm.endTimeInHours = 17;
		this.vm.user = this.session.getSession().user;
		
		this.vm.redirectToWordCLoud = this.redirectToWordCLoud;
		
		var currentBookingPreliminaryCheck = this.vm.bookingPreliminaryCheck;
		this.watcher = this.angularHelperService.createInterval(() => {
			if (!this.angularHelperService.isEqual(currentBookingPreliminaryCheck, this.vm.bookingPreliminaryCheck)) {
				currentBookingPreliminaryCheck = Object.assign({}, this.vm.bookingPreliminaryCheck);
				this.handleBookingPreliminaryCheckStateChange(this.vm.bookingPreliminaryCheck);
			}
		}, 300);
		
		this.executeBookingPreliminaryCheck();
	}
	
	executeBookingPreliminaryCheck() {
		this.conciergeService.getBookingPreliminaryCheck(this.vm.serviceId)
			.then((response) => {
				this.vm.bookingPreliminaryCheck = response;
			})
			.catch((error) => {
				console.error(error);
			});
	}
	
	handleBookingPreliminaryCheckStateChange(bookingPreliminaryCheck) {
		var preliminaryCheckSettings: any = bookingPreliminaryCheck['preliminaryCheckSettings'] || {};
		this.vm.startTimeInHours = preliminaryCheckSettings['startTimeInHours'];
		this.vm.endTimeInHours = preliminaryCheckSettings['endTimeInHours'];
		this.vm.isClosed = this.config.isOnDemandServiceUnavailable(preliminaryCheckSettings);
	}
	
	redirectToWordCLoud() {
		this.angularRoutingHelperService.clearQueryParamsDirty();
		this.angularRoutingHelperService.setPath('/booking/mental-check', false, false, { step: 'CONSULTANT' });
	}
	
}